import { useSelector } from 'src/store';
import { selectors } from 'src/store/navbar';

export const useIsContentShowing = () => useSelector(selectors.selectIsContentShowing);
